import React, { createContext, useReducer } from 'react'
import { Reducer } from './Reducer'
import { OrderReducer } from './OrderReducer'

export const UserContext = createContext()

const UserProvider = ({ children }) => {


    const [user, dispatch] = useReducer(Reducer, 
        
        JSON.parse(window.localStorage.getItem('user')) || {

            data: null,
            loggedIn: false,
            address: [],
            extra: {}  
            
        }
    
    )


    const [order, changeOrder] = useReducer(OrderReducer,

        JSON.parse(window.localStorage.getItem('order')) || {

            status: false,
            bebidas: [],
            tipo: '0',
            user: '',
            total: 0,
            direccion: {}
            
        })


    return (

        <UserContext.Provider value={{ user, dispatch, order, changeOrder }}>
            {children}
        </UserContext.Provider>
    )
}

export default UserProvider